import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Records";
import getToken from "app/api/getToken";
import { IRecordRequest } from "app/api/types";

export const EDIT_RECORD_REQUEST = "EDIT_RECORD_REQUEST";
export const EDIT_RECORD_SUCCESS = "EDIT_RECORD_SUCCESS";
export const EDIT_RECORD_FAIL = "EDIT_RECORD_FAIL";

export const editRecord = (data: IRecordRequest) => (dispatch: any): any => {
  dispatch({ type: EDIT_RECORD_REQUEST });

  const token = getToken();

  return api
    .editRecord(token, data)
    .then((response: AxiosResponse) => {
      const master: IRecordRequest = get(response, "data", {});
      dispatch({ type: EDIT_RECORD_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: EDIT_RECORD_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
